module.exports = __webpack_public_path__ + "img/pvsyst.2d31f8cc.png";